<template>
  <div>
    <h4>Dados da Pessoa</h4>
    <table class="table table-bordered table-hover" role="grid">
      <tbody>
        <tr role="row" class="odd">
          <td>
            <b>Nome/Razão:</b>
          </td>
          <td>{{ apiData.nome_razao }}</td>
        </tr>
        <tr role="row" class="odd">
          <td>
            <b>Cpf/Cnpj:</b>
          </td>
          <td>{{ apiData.cpf_cnpj }}</td>
        </tr>
        <tr role="row" class="odd">
          <td>
            <b>Telefones:</b>
          </td>
          <td>
            {{ apiData.telefone1 ? apiData.telefone1 : '' }}
            {{ apiData.telefone2 ? ' | ' + apiData.telefone2 : '' }}
            {{ apiData.tel_ref_comercial ? ' | ' + apiData.tel_ref_comercial : '' }}
            {{ apiData.tel_ref_pessoal ? ' | ' + apiData.tel_ref_pessoal : '' }}
          </td>
        </tr>
      </tbody>
    </table>

    <h4 class="mt-20">Boletos Pendentes</h4>
    <table class="table table-bordered" role="grid">
      <thead>
        <tr role="row">
          <th style="width:auto">Empresa</th>
          <th style="width:auto">Protocolo</th>
          <th style="width:auto">Garantia</th>
          <th style="width:auto">Vencimento</th>
          <th style="width:auto">Dias de Atraso</th>
          <th style="width:auto">Valor</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="garantia in apiData.garantias">
          <tr v-for="boleto in garantia.boletos" :key="boleto.id">
            <td>{{ garantia.usuario.empresa.fantasia }}</td>
            <td>{{ garantia.id }}.{{garantia.digito}}</td>
            <td>{{ boleto.id }}.{{ boleto.digito }}</td>
            <td>{{ boleto.vencimento | dataFormatada }}</td>
            <td>{{ diasAtraso(boleto.vencimento) }}</td>
            <td>{{ boleto.valor_garantido | numberFormat(2,',','.') }} 
              <span style="float:right">
                <button @click="negativarCliente(boleto.id)" class="btn btn-danger btn-sm" title="Incluir no SPC">
                  <i class="fa fa-fw fa-thumbs-down"></i>
                </button>
              </span>
            </td>
          </tr>
        </template>
      </tbody>
      <tfoot>
        <tr role="row" class="odd">
          <td class="text-right" colspan="5">
            <b>Total do débito sem Juros</b>
          </td>
          <td>{{ total | numberFormat(2,',','.') }}</td>
        </tr>
        <tr role="row" class="odd">
          <td class="text-right" colspan="5">
            <b>Valor atualizado</b>
          </td>
          <td>{{ valorAtualizado | numberFormat(2,',','.') }}</td>
        </tr>
      </tfoot>
    </table>
    <h4 class="mt-40">Simulação</h4>
    <div class="row d-flex aling-flex-end">
      <div class="col-xs-5 col-md-3">
        <div class="form-group">
          <select class="form-control" v-model="dados.qtdParcelas">
            <option value>Qtd de Parcelas</option>
            <option value="1">01</option>
            <option value="2">02</option>
            <option value="3">03</option>
            <option value="4">04</option>
            <option value="5">05</option>
            <option value="6">06</option>
            <option value="7">07</option>
            <option value="8">08</option>
            <option value="9">09</option>
            <option value="10">10</option>
          </select>
        </div>
      </div>
      <div class="col-xs-7 col-md-9">
        <p
          class
        >Simulação: 2% de multa + 14,90(taxa de administração) + juros de 0,33% ao dia para boletos ou 0,033% ao dia para cheques.</p>
      </div>
    </div>
    <div v-if="parcelas.length > 0">
      <table class="table table-bordered" role="grid">
        <thead>
          <tr role="row">
            <th style="width:auto">Parcela</th>
            <th style="width:auto">Vencimento</th>
            <th style="width:auto">Valor</th>
          </tr>
        </thead>
        <tbody>
          <tr role="row" class="odd" v-for="(item, index) in parcelas" :key="index">
            <td>
              <b>{{ item.parcela }}ª Parcela</b>
            </td>
            <td>
              <div :class="{'form-group': true, 'has-error':errors.has('data') }">
                <input
                  v-validate="'required'"
                  type="date"
                  name="data"
                  class="form-control"
                  v-model="item.vencimento"
                />
                <span v-show="errors.has('data')" class="help-block">Campo obrigatório</span>
              </div>
            </td>
            <td>
              <div :class="{'form-group': true, 'has-error':errors.has('valor') }">
                <money
                  v-if="index == 0"
                  ref="valor"
                  class="form-control"
                  v-model="item.valor"
                  v-bind="money"
                  v-validate="'required'"
                  name="valor"
                ></money>
                <span v-show="errors.has('valor')" class="help-block">Campo obrigatório</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!acordo.simulacao" class="text-center">
        <button class="btn btn-primary" @click="simular()">Simular</button>
      </div>
    </div>

    <div v-if="acordo.simulacao">
      <h4 class="mt-40">Resultado da Simulação</h4>
      <div class="row d-flex aling-flex-end">
        <div class="col-md-3">
          <label>Valor Atualizado</label>
          <input disabled class="form-control" :value="valorAtualizado | numberFormat(2,',','.')" />
        </div>
        <div class="col-md-3">
          <label>Desconto</label>
          <money class="form-control" v-model="acordo.desconto" v-bind="money"></money>
        </div>
        <div class="col-md-3">
          <label>Valor total do parcelamento</label>
          <input
            disabled
            class="form-control"
            :value="acordo.totalParcelamento | numberFormat(2,',','.')"
          />
        </div>
        <div class="col-md-3">
          <button class="btn btn-primary mt-20" @click="simular()">Refazer Simulação</button>
        </div>
      </div>
      <div class="mt-20" v-if="parcelas.length > 0">
        <table class="table table-bordered" role="grid">
          <thead>
            <tr role="row">
              <th style="width:auto">Parcela</th>
              <th style="width:auto">Vencimento</th>
              <th style="width:auto">Valor</th>
            </tr>
          </thead>
          <tbody>
            <tr role="row" class="odd" v-for="(item, index) in acordo.parcelas" :key="index">
              <td>
                <b>{{ item.parcela }}ª Parcela</b>
              </td>
              <td>{{ item.vencimento | dataFormatada }}</td>
              <td>{{ item.valor | numberFormat(2,',','.') }}</td>
            </tr>
          </tbody>
        </table>

        <div class="text-right">
          <button class="btn btn-defalt" @click="cancelarSimulacao()">Cancelar</button>
          <button class="btn btn-primary" @click="efetivarAcordo()">Efetivar Acordo</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"; // Cliente para requisição http
import { mask } from "vue-the-mask";
import { Money } from "v-money";

export default {
  directives: { mask },
  components: {
    Money,
  },
  props: ["pessoaId"],
  data: () => ({
    money: {
      decimal: ",",
      thousands: ".",
      prefix: "R$ ",
      precision: 2,
      masked: false,
    },
    acordo: {
      simulacao: false,
      desconto: 0,
      parcelas: [],
      totalParcelamento: 0,
    },
    dados: {
      qtdParcelas: "",
    },
    apiData: {
      garantias: [],
    },
  }),
  mounted() {
    if (this.pessoaId) {
      this.getDetalhe(this.pessoaId);
    }
  },
  computed: {
    total() {
      let res = 0;
      this.apiData.garantias.forEach((garantia) => {
        res =
          res +
          garantia.boletos.reduce(
            (acc, item) => acc + parseFloat(item.valor_garantido),
            0
          );
      });
      return res;
    },
    valorAtualizado() {
      let multa = 2 * (this.total / 100);
      let totalJutos = 0;
      this.apiData.garantias.forEach((garantia) => {
        garantia.boletos.forEach((item) => {
          totalJutos =
            totalJutos +
            ((0.33 * item.valor_garantido) / 100) *
              this.diasAtraso(item.vencimento);
        });
      });
      return this.total + multa + totalJutos + 14.9;
    },
    parcelas() {
      let array = [];
      let i = 0;
      for (i; i < parseInt(this.dados.qtdParcelas); i++) {
        array[i] = { parcela: i + 1, vencimento: "", valor: "" };
      }
      return array;
    },
  },
  methods: {
    simular() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.acordo.parcelas = [];
          let totalJuros = 0; // juros total calculado
          let quantidadeParcelas = this.parcelas.length - 1; // numero de parcelas menos a entrada
          let valorParcelas =
            (this.valorAtualizado - this.parcelas[0].valor) /
            quantidadeParcelas; // valor das parcelas menos a entrada

          this.parcelas.forEach((parcela, index) => {
            // calcula o juros total das parcelas
            if (index > 0) {
              totalJuros =
                totalJuros +
                ((0.33 * valorParcelas) / 100) *
                  this.diasAtraso(parcela.vencimento);
            }
          });

          this.acordo.totalParcelamento = this.valorAtualizado + totalJuros; // valor atualizado do acordo
          let valorPArcelasAtualizada =
            (this.acordo.totalParcelamento -
              this.acordo.desconto -
              this.parcelas[0].valor) /
            quantidadeParcelas; // valor das parcelas com juros e desconto

          this.parcelas.forEach((item, index) => {
            if (index == 0) {
              this.acordo.parcelas[index] = {
                parcela: item.parcela,
                vencimento: item.vencimento,
                valor: item.valor,
                situacao: "Em Aberto",
              };
            } else {
              this.acordo.parcelas[index] = {
                parcela: item.parcela,
                vencimento: item.vencimento,
                valor: valorPArcelasAtualizada,
                situacao: "Em Aberto",
              };
            }
          });

          console.log(this.acordo.parcelas);
          this.acordo.simulacao = true;
        }
      });
    },
    efetivarAcordo() {
      this.$swal({
        title: "Confirmação Acordo!",
        text: "Confirma a efetivação do acordo?",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
        cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          let dados = {
            descricao: null,
            valor: this.acordo.totalParcelamento,
            desconto: this.acordo.desconto,
            valor_sem_juros: this.total,
            valor_atualizado: this.valorAtualizado,
            ultimo_vencimento: this.acordo.parcelas[this.acordo.parcelas.length - 1].vencimento,
            numero_parcelas: this.acordo.parcelas.length,
            status: "Aguardando Ativação",
            data_cancelamento: null,
            user_cancelamento_id: null,
            pessoa_id: this.apiData.id,
            user_id: this.apiData.garantias[0].usuario.id,
            parcelas: this.acordo.parcelas,
          };
          console.log(dados);
          let config = this.$store.getters.getHeaderAuth;
          axios
            .post(
              `${this.$store.state.serverURI}/api/acordo/create`,
              dados,
              config
            )
            .then((response) => {
              this.$swal({
                type: "success",
                title: "Tudo Certo!",
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(response.data);
            })
            .catch((error) => {
              this.$store.commit("throwException", error);
            });
        }
      });
    },
    cancelarSimulacao() {
      this.acordo.desconto = 0;
      this.acordo.parcelas = [];
      this.acordo.totalParcelamento = 0;
      this.acordo.simulacao = false;
    },
    negativarCliente(boletoId) {
      this.$swal({
        title: "Inclusão no SPC",
        text: "Confirma a inclusão do cliente no SPC com as informações desse boleto?",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
        cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          let config = this.$store.getters.getHeaderAuth;
          config.params = null;
          axios
            .post(
              `${this.$store.state.serverURI}/api/acordo/incluir-spc`,
              {boletoId: boletoId},
              config
            )
            .then((response) => {
              this.$swal({
                type: "success",
                title: "Tudo Certo!",
                showConfirmButton: false,
                timer: 1500,
              });
              this.$router.push("/cobranca/inadimplentes");
            })
            .catch((error) => {
              this.$store.commit("throwException", error);
            });
        }
      });
    },
    diasAtraso(vencimento) {
      let diff = Math.abs(
        new Date().getTime() - new Date(vencimento).getTime()
      );
      return Math.ceil(diff / (1000 * 3600 * 24)) - 1;
    },
    getDetalhe(pessoaId) {
      let config = this.$store.getters.getHeaderAuth;
      axios
        .get(
          `${this.$store.state.serverURI}/api/pessoa/getInadimplenteById/${pessoaId}`,
          config
        )
        .then((response) => {
          console.log(response.data);
          this.apiData = response.data;
        })
        .catch((error) => {
          this.$store.commit("throwException", error);
        });
    },
  },
};
</script>
<style scoped>
.p-10 {
  padding: 10px;
}
.mt-10 {
  margin-top: 10px;
}
.mt-20 {
  margin-top: 20px;
}
.mt-40 {
  margin-top: 40px;
}
.fw-600 {
  font-weight: 600;
}
.d-flex {
  display: flex;
}
.aling-flex-end {
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// inadimplenteAcordo.vue?641fb13e